import React, { FC, memo, PropsWithChildren } from 'react';
import { Container } from '~/templates/blocks/components/container/container.component';
import { ClubOverlays } from '~/features/club';
import styles from './header-wrapper.module.css';
import clsx from 'clsx';

type Props = PropsWithChildren & {
    className?: string;
    innerClassName?: string;
    isSearchPage?: boolean;
};

const HeaderWrapper: FC<Props> = memo(({ className, children, innerClassName, isSearchPage }) => (
    <>
        <header className={styles.root}>
            <div className={className}>
                <Container
                    hasGutter
                    spacingTop="none"
                    spacingBottom="none"
                    className={clsx(styles.innerRoot, innerClassName, {
                        [styles.searchPage]: isSearchPage,
                    })}
                >
                    {children}
                </Container>
            </div>
        </header>
        <ClubOverlays />
    </>
));

HeaderWrapper.displayName = 'HeaderWrapper';
export default HeaderWrapper;
